import React,{Component} from 'react'

import {
  Avatar,
  // Chip,
  // Hidden,
  Tooltip,
} from 'material-ui'

import {
  Accent,
  // Primary,
  // Purple,
  Green,
  // LightGray,
  bgWhite,
} from '../helper/consts'

// const colors = [Primary,Accent,Purple,Green,LightGray]

const style = {
  jobStatus:{
    position: 'absolute',
    right: '10px',
    textTransform: 'capitalize',
  },
  published:{
    backgroundColor: Green,
    height:'15px',
    width:'15px',
    marginRight:'8px',
    boxShadow: `${bgWhite} 0 -1px 7px 1px, inset ${Green} 0 -1px 9px, #89FF00 0 2px 12px`
  },
  hired:{
    backgroundColor: Accent,
    height:'15px',
    width:'15px',
    marginRight:'8px',
    boxShadow: `${bgWhite} 0 -1px 7px 1px, inset ${Accent} 0 -1px 9px, #f97fa8 0 2px 12px`
  }
}

export default class JobCardStatusIndicatorChip extends Component{
  render(){
    const {job}=this.props;
    return(
      <Tooltip id="tooltip-top" title={`${job.status}`} placement="top">
        <Avatar style={job.status==='published'?style.published:style.hired} ></Avatar>
      </Tooltip>
    )
  }
}
// <Hidden smDown>
//   <Chip
//     style={style.jobStatus}
//     label={job.status}
//     avatar={<Avatar style={job.status==='published'?style.published:style.hired} ></Avatar>}
//   />
// </Hidden>



// WEBPACK FOOTER //
// ./src/components/JobCardStatusIndicatorChip.js